<template>
    <div v-show="show2FAModal">
        <div>
            <p class="text-sm mb-4">
                Enter the verification code sent to this phone:
                <br />
                (###)-###-{{ phone }}
            </p>

            <VOtpInput
                ref="otpInput"
                input-classes="otp-input"
                inputType="numeric"
                :num-inputs="6"
                v-model:value="code"
                :should-auto-focus="true"
                :should-focus-order="true"
                class="mb-4"
            />

            <p class="text-sm mb-4">
                Didn't get your code?
                <a
                    class="link"
                    href="#"
                    @click.prevent="loginStore.resendCode()"
                    role="button"
                    v-if="!resending"
                >
                    Send a new code
                </a>
                <span
                    v-if="resending"
                    class="inline-block ml-1"
                >{{ resendCodeMessage }}</span>
            </p>

            <Errors :errors="errors" class="mb-4" />

            <ActionButton
                @clicked="loginStore.submitCode()"
                label="Continue sign in"
                :loading="sendingCode"
                classes="bg-slate-800 hover:bg-slate-600 text-sm px-4 py-2.5 rounded shadow transition-colors text-white font-medium w-full mb-3"
            />

            <button
                v-if="!showRecoveryCode"
                class="w-full flex items-center gap-2 justify-center px-4 py-2.5 bg-white dark:bg-slate-800 rounded text-slate-800 dark:text-slate-100 text-sm font-medium hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                @click="loginStore.cancelSms()"
            >
                Back to sign in
            </button>
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useLoginStore } from '@/store/login';
import { ref, watch } from 'vue';
import ActionButton from '@/components/action-button.vue';
import VOtpInput from 'vue3-otp-input';
import Errors from '@/components/errors.vue';

const loginStore = useLoginStore();
const {
    code,
    showRecoveryCode,
    errors,
    sendingCode,
    resending,
    resendCodeMessage,
    showResendCode,
} = storeToRefs(loginStore);

defineProps({
    show2FAModal: {
        type: Boolean,
        default: false,
    },
    twoFactorType: {
        type: String,
        default: 'login',
    },
    phone: {
        type: String,
        default: '',
    },
    intended: {
        type: String,
        default: '',
    },
    mode: {
        type: String,
        default: 'login',
    },
    user: {
        type: Object,
        default: () => {},
    },
});

const otpInput = ref(null);

watch(showResendCode, (value) => {
    if (value) {
        otpInput.value?.clearInput();
    }
});
</script>
